export default {"src":"/_next/static/media/0x3c2b8be99c50593081eaa2a724f0b8285f5aba8f.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};